import { createBrowserRouter } from "react-router-dom";
import { ThemeContextProvider } from "./context/ThemeState";
import { Home, Projects } from "./pages";
import AGB from "./pages/Legal/AGB";
import Impressum from "./pages/Legal/Impressum";

export const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <ThemeContextProvider>
        <Home />
      </ThemeContextProvider>
    ),
  },
  {
    path: "projects",
    element: (
      <ThemeContextProvider>
        <Projects />
      </ThemeContextProvider>
    ),
  },
  {
    path: "impressum",
    element: (
      <ThemeContextProvider>
        <Impressum />
      </ThemeContextProvider>
    ),
  },
  {
    path: "agb",
    element: (
      <ThemeContextProvider>
        <AGB />
      </ThemeContextProvider>
    ),
  },
]);
